var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "externalSupport" } }, [
    _c(
      "div",
      { staticClass: "vo-external-card" },
      [
        _c("vo-external-header", { attrs: { title: _vm.title } }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vo-body" },
          [
            _c("div", { staticClass: "vo-title" }, [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _c("div", { staticClass: "vo-context" }, [
              _vm._v(
                "Having issues with Vilio? Have a question? Let us know and we'll get back to you as soon as possible. You can also try using our "
              ),
              _c("a", { attrs: { href: _vm.feedback, target: "_blank" } }, [
                _vm._v("Feedback system")
              ]),
              _vm._v(
                " to report bugs, give suggestions, and help shape the future of Vilio."
              )
            ]),
            _vm._v(" "),
            _c("v-text-field", {
              ref: "emailInput",
              attrs: {
                disabled: _vm.lockout,
                "validate-on-blur":
                  _vm.$refs.emailInput && _vm.$refs.emailInput.valid,
                label: "Email Address",
                type: "email",
                rules: _vm.rules.email
              },
              model: {
                value: _vm.email,
                callback: function($$v) {
                  _vm.email = $$v
                },
                expression: "email"
              }
            }),
            _vm._v(" "),
            _c("v-text-field", {
              ref: "messageInput",
              attrs: {
                disabled: _vm.lockout,
                "validate-on-blur":
                  _vm.$refs.messageInput && _vm.$refs.messageInput.valid,
                label: "Message...",
                type: "text",
                "multi-line": "",
                maxrows: "3",
                maxlength: "2000",
                "no-resize": "",
                rules: _vm.rules.message
              },
              model: {
                value: _vm.message,
                callback: function($$v) {
                  _vm.message = $$v
                },
                expression: "message"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "v-btn",
          {
            directives: [{ name: "ripple", rawName: "v-ripple" }],
            staticClass: "vo-card-button",
            attrs: { block: "", flat: "", loading: _vm.lockout },
            on: { click: _vm.sendMessage }
          },
          [_vm._v("SEND MESSAGE")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f85d184", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f85d184","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalSupport.vue
// module id = 663
// module chunks = 4